import { DISCColor } from './types';

// =============================================================================
// DISC TEST QUESTIONS
// =============================================================================
//
// 15 vragen die je persoonlijkheidstype bepalen:
// - Rood (Dominant): Doelgericht, besluitvaardig, directief
// - Geel (Invloedrijk): Enthousiast, sociaal, optimistisch
// - Groen (Stabiel): Geduldig, betrouwbaar, teamgericht
// - Blauw (Consciëntieus): Analytisch, precies, systematisch
//
// =============================================================================

export interface DISCQuestionOption {
  text: string;
  color: DISCColor;
}

export interface DISCQuestion {
  id: number;
  question: string;
  options: DISCQuestionOption[];
}

export const DISC_QUESTIONS: DISCQuestion[] = [
  {
    id: 1,
    question: 'Bij een nieuw project...',
    options: [
      { text: 'Begin ik direct, geen tijd te verliezen', color: 'red' },
      { text: 'Brainstorm ik enthousiast met anderen', color: 'yellow' },
      { text: 'Vraag ik eerst wat anderen ervan vinden', color: 'green' },
      { text: 'Maak ik eerst een gedetailleerd plan', color: 'blue' }
    ]
  },
  {
    id: 2,
    question: 'In een vergadering ben ik meestal...',
    options: [
      { text: 'Degene die de leiding neemt en beslissingen forceert', color: 'red' },
      { text: 'Degene die het gesprek gaande houdt en energie brengt', color: 'yellow' },
      { text: 'Degene die goed luistert en consensus zoekt', color: 'green' },
      { text: 'Degene die de details checkt en vragen stelt', color: 'blue' }
    ]
  },
  {
    id: 3,
    question: 'Als ik gestrest ben...',
    options: [
      { text: 'Word ik directief en ongeduldig', color: 'red' },
      { text: 'Praat ik veel en ben ik chaotisch', color: 'yellow' },
      { text: 'Trek ik me terug en vermijd conflict', color: 'green' },
      { text: 'Analyseer ik alles tot in detail', color: 'blue' }
    ]
  },
  {
    id: 4,
    question: 'Ik krijg energie van...',
    options: [
      { text: 'Uitdagingen en competitie', color: 'red' },
      { text: 'Sociale interactie en brainstormen', color: 'yellow' },
      { text: 'Rust, routine en samenwerking', color: 'green' },
      { text: 'Structuur, data en precisie', color: 'blue' }
    ]
  },
  {
    id: 5,
    question: 'Bij een probleem...',
    options: [
      { text: 'Pak ik het direct aan en los het snel op', color: 'red' },
      { text: 'Betrek ik anderen om samen een oplossing te vinden', color: 'yellow' },
      { text: 'Denk ik na over hoe het iedereen beïnvloedt', color: 'green' },
      { text: 'Analyseer ik eerst alle mogelijke oorzaken', color: 'blue' }
    ]
  },
  {
    id: 6,
    question: 'Mijn communicatiestijl is...',
    options: [
      { text: 'Direct en to the point', color: 'red' },
      { text: 'Enthousiast en expressief', color: 'yellow' },
      { text: 'Kalm en vriendelijk', color: 'green' },
      { text: 'Precies en feitelijk', color: 'blue' }
    ]
  },
  {
    id: 7,
    question: 'Bij verandering...',
    options: [
      { text: 'Neem ik de leiding en duw ik door', color: 'red' },
      { text: 'Zie ik de mogelijkheden en inspireer ik anderen', color: 'yellow' },
      { text: 'Ben ik voorzichtig en wil ik eerst zekerheid', color: 'green' },
      { text: 'Wil ik alle details en risico\'s begrijpen', color: 'blue' }
    ]
  },
  {
    id: 8,
    question: 'In een team ben ik meestal...',
    options: [
      { text: 'De leider die richting geeft', color: 'red' },
      { text: 'De motivator die enthousiasme brengt', color: 'yellow' },
      { text: 'De supporter die iedereen helpt', color: 'green' },
      { text: 'De specialist die expertise inbrengt', color: 'blue' }
    ]
  },
  {
    id: 9,
    question: 'Mijn grootste angst is...',
    options: [
      { text: 'Controle verliezen', color: 'red' },
      { text: 'Afgewezen worden', color: 'yellow' },
      { text: 'Plotselinge verandering', color: 'green' },
      { text: 'Fouten maken', color: 'blue' }
    ]
  },
  {
    id: 10,
    question: 'Bij een deadline...',
    options: [
      { text: 'Push ik door en zorg dat het af komt', color: 'red' },
      { text: 'Motiveer ik het team om samen te werken', color: 'yellow' },
      { text: 'Blijf ik rustig en werk gestaag door', color: 'green' },
      { text: 'Check ik alles nauwkeurig voordat ik inlever', color: 'blue' }
    ]
  },
  {
    id: 11,
    question: 'Mijn werkstijl is...',
    options: [
      { text: 'Snel, resultaatgericht, geen tijd voor details', color: 'red' },
      { text: 'Creatief, spontaan, multitasking', color: 'yellow' },
      { text: 'Stabiel, geduldig, stap voor stap', color: 'green' },
      { text: 'Systematisch, precies, grondig', color: 'blue' }
    ]
  },
  {
    id: 12,
    question: 'Bij kritiek...',
    options: [
      { text: 'Verdedig ik mezelf direct', color: 'red' },
      { text: 'Neem ik het persoonlijk op', color: 'yellow' },
      { text: 'Ga ik naar binnen en denk er over na', color: 'green' },
      { text: 'Vraag ik om concrete voorbeelden', color: 'blue' }
    ]
  },
  {
    id: 13,
    question: 'Mijn besluitvorming is...',
    options: [
      { text: 'Snel en intuïtief', color: 'red' },
      { text: 'Gebaseerd op wat anderen denken', color: 'yellow' },
      { text: 'Voorzichtig, na goed overleg', color: 'green' },
      { text: 'Gebaseerd op data en feiten', color: 'blue' }
    ]
  },
  {
    id: 14,
    question: 'Als ondernemer ben ik goed in...',
    options: [
      { text: 'Snel beslissingen nemen en doorpakken', color: 'red' },
      { text: 'Netwerken, verkopen en presenteren', color: 'yellow' },
      { text: 'Relaties opbouwen en teamwork', color: 'green' },
      { text: 'Processen, systemen en kwaliteit', color: 'blue' }
    ]
  },
  {
    id: 15,
    question: 'Mijn grootste zwakte als ondernemer is...',
    options: [
      { text: 'Ongeduld, details over het hoofd zien', color: 'red' },
      { text: 'Moeilijk focussen, veel beginnen weinig afmaken', color: 'yellow' },
      { text: 'Moeite met verandering en risico nemen', color: 'green' },
      { text: 'Te perfectionistisch, langzaam in actie', color: 'blue' }
    ]
  }
];

// =============================================================================
// DISC PROFILE DESCRIPTIONS
// =============================================================================

export interface DISCProfileDescription {
  title: string;
  description: string;
  entrepreneurialStrengths: string[];
  entrepreneurialWeaknesses: string[];
  idealRoles: string[];
  needsSupport: string[];
}

export const DISC_PROFILE_DESCRIPTIONS: Record<DISCColor, DISCProfileDescription> = {
  red: {
    title: 'Doener / Leider',
    description: 'Je bent resultaatgericht, besluitvaardig en houdt van uitdagingen. Je neemt graag de leiding en pusht door om doelen te bereiken.',
    entrepreneurialStrengths: [
      'Snelle beslissingen nemen',
      'Directe communicatie',
      'Risico\'s durven nemen',
      'Resultaatgericht werken',
      'Leiderschap tonen'
    ],
    entrepreneurialWeaknesses: [
      'Kan ongeduldig zijn',
      'Details over het hoofd zien',
      'Weinig tijd voor relaties',
      'Kan te directief zijn',
      'Moeite met luisteren'
    ],
    idealRoles: ['Strategie', 'Sales', 'Leiderschap'],
    needsSupport: ['Administratie', 'Details', 'Geduld', 'Teambuilding']
  },
  yellow: {
    title: 'Netwerker / Inspirator',
    description: 'Je bent enthousiast, sociaal en optimistisch. Je houdt van mensen, brainstormen en anderen inspireren met je energie.',
    entrepreneurialStrengths: [
      'Netwerken en relaties opbouwen',
      'Presenteren en verkopen',
      'Enthousiasme overbrengen',
      'Creatief denken',
      'Mensen motiveren'
    ],
    entrepreneurialWeaknesses: [
      'Moeite met focus behouden',
      'Veel beginnen, weinig afmaken',
      'Details vermijden',
      'Te optimistisch over timing',
      'Structuur ontbreekt'
    ],
    idealRoles: ['Marketing', 'Sales', 'Netwerken', 'Presentaties'],
    needsSupport: ['Planning', 'Structuur', 'Follow-up', 'Details', 'Financiën']
  },
  green: {
    title: 'Teamspeler / Supporter',
    description: 'Je bent geduldig, betrouwbaar en teamgericht. Je houdt van stabiliteit, samenwerking en een goede werksfeer.',
    entrepreneurialStrengths: [
      'Relaties opbouwen',
      'Goed luisteren',
      'Teamwork faciliteren',
      'Geduldig en consistent',
      'Klantgericht werken'
    ],
    entrepreneurialWeaknesses: [
      'Moeite met verandering',
      'Risico\'s vermijden',
      'Moeilijk nee zeggen',
      'Langzaam in beslissingen',
      'Conflict vermijden'
    ],
    idealRoles: ['Klantenservice', 'Team building', 'Operaties'],
    needsSupport: ['Strategie', 'Snelle beslissingen', 'Sales', 'Groei/schaal']
  },
  blue: {
    title: 'Analist / Specialist',
    description: 'Je bent analytisch, precies en systematisch. Je houdt van data, kwaliteit en alles goed georganiseerd hebben.',
    entrepreneurialStrengths: [
      'Systemen opzetten',
      'Kwaliteit waarborgen',
      'Data analyseren',
      'Risico\'s inschatten',
      'Grondig plannen'
    ],
    entrepreneurialWeaknesses: [
      'Te perfectionistisch',
      'Langzaam in actie',
      'Moeite met onzekerheid',
      'Social skills beperkt',
      'Flexibiliteit ontbreekt'
    ],
    idealRoles: ['Financiën', 'Operaties', 'Product/kwaliteit', 'Processen'],
    needsSupport: ['Marketing', 'Sales', 'Netwerken', 'Snelheid', 'Flexibiliteit']
  }
};
